export default __webpack_public_path__ + "static/media/image4.6ba35531.jpg";